import { useRef } from 'react'

export function useLastData<ST>(data: ST) {
  const ref = useRef(data)
  if (data !== null && data !== undefined) {
    ref.current = data
  }
  return ref.current
}
